import { useProContext } from 'store/ProReducer/useProContext';

export const useCheckPlug = () => {
  const { isCosmetology, isNails, isPermanent } = useProContext();

  return isCosmetology
    ? 'cosmetology'
    : isPermanent
    ? 'permanent'
    : isNails
    ? 'nails'
    : 'hairmakeup';
};
